import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { IAfterGuiAttachedParams } from 'ag-grid-community';
import { RouterLink } from '@angular/router';
import { MatTooltip } from '@angular/material/tooltip';
import { NgIf } from '@angular/common';

@Component({
    selector: 'payment-report-paymentable-cell',
    template: ` <a
    [matTooltip]="tooltip"
    matTooltip-position="left"
    tooltipHideDelay="0"
    *ngIf="text"
    [routerLink]="link"
  >
    {{ text }}
  </a>`,
    standalone: true,
    imports: [NgIf, MatTooltip, RouterLink]
})
export class PaymentReportPaymentableCellComponent
  implements AgRendererComponent
{
  private value: {
    type: 'booking' | 'docket' | 'repairDocket' | 'saleDocket';
    id: number;
    invoice_number: number;
  };

  text: string;
  tooltip: string;
  link: any[];

  agInit(params: any): void {
    if (params.value) {
      this.value = params.value;
    }
    this.populateValues();
  }

  populateValues() {
    if (!this.value) {
      this.text = 'Unknown';
      this.tooltip = 'Unknown';
      this.link = ['/'];
      return;
    }
    const { type, id, invoice_number } = this.value;
    switch (type) {
      case 'booking':
        this.text = `Booking ${id}`;
        this.tooltip = 'View Booking';
        this.link = ['/bookings/view', id];
        break;
      case 'docket':
        this.text = invoice_number ? `HI ${invoice_number}` : `HC ${id}`;
        this.tooltip = invoice_number ? 'Hire Invoice' : 'Hire Contract';
        this.link = ['/docket', id];
        break;
      case 'repairDocket':
        this.text = invoice_number ? `RI ${invoice_number}` : `RD ${id}`;
        this.tooltip = invoice_number ? 'Repair Invoice' : 'Repair Docket';
        this.link = ['/repair-docket', this.value.id];
        break;
      case 'saleDocket':
        this.text = invoice_number ? `SI ${invoice_number}` : `SD ${id}`;
        this.tooltip = invoice_number ? 'Sale Invoice' : 'Sale Docket';
        this.link = ['/sale-docket', this.value.id];
        break;
      default:
        this.text = 'Unknown';
        this.tooltip = 'Unknown';
        this.link = ['/'];
    }
  }

  refresh(params: any): boolean {
    this.value = params.value;
    return true;
  }

  afterGuiAttached?(params?: IAfterGuiAttachedParams): void {}
}
